import Reveal from '@/pages/zz-review/components/Reveal';

const uses = [
  { icon: 'ri-book-2-line', title: '書籍印製與打樣', body: '360 頁書籍印製、封面加工與實體打樣。' },
  { icon: 'ri-box-3-line', title: '包材與物流', body: '包材、拆理、臺灣與海外物流。' },
  { icon: 'ri-bank-card-line', title: '平台與金流', body: '平台及金流費用，以及發票與稅務處理。' },
  { icon: 'ri-compass-3-line', title: '實踐導航工具', body: '導航卡、書籤、數位實踐入口與基礎維運。' },
  { icon: 'ri-shield-line', title: '風險準備', body: '瑕疵、補寄、物流調整與不可預期支出。' },
];

const timeline = [
  { date: '已完成', title: '預告專案', body: '公布書封與出版計畫。' },
  { date: '審核中', title: '嘖嘖專案審核中', body: '正式上線日期將於審核通過後公告。' },
  { date: '另行公告', title: '募資結束', body: '統計贊助數量與款項。' },
  { date: '另行公告', title: '款項結算、正式下單', body: '數量確認後正式下單印製。' },
  { date: '另行公告', title: '印製與品質檢查', body: '印製、品質檢查、包裝與分批出貨。' },
  { date: '另行公告', title: '完成臺灣批次寄送', body: '海外件視物流工作天順延。' },
];

export default function FundingSection() {
  return (
    <section id="funding" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              資金用途與履約時程
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              你的支持，會落在哪裡
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              募資成功後的淨額將優先用於本書首批實體印製與贊助者履約。實際比例將依贊助數量、印製報價與配送地區調整，不作虛假的精確比例承諾。
            </p>
          </div>
        </Reveal>

        <Reveal delay={40}>
          <div className="rounded-lg border border-primary-200/70 bg-primary-50 px-6 md:px-10 py-8 text-center mb-14">
            <p className="text-xs tracking-[0.2em] uppercase text-primary-800 mb-3">
              募資目標
            </p>
            <p
              className="text-3xl md:text-4xl text-foreground-900 font-semibold"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              NT$50,000
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mt-3">
              優先用於實體打樣與首批印製、封面與裝訂、包材物流、平台金流與稅務、隨書導航工具，以及 RG Portal 三次 AI Angel 體驗的基礎維運。
            </p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
            {uses.map((u) => (
              <div
                key={u.title}
                className="rounded-lg border border-background-200/70 bg-background-100 px-5 py-5 flex items-start gap-3"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-800 shrink-0">
                  <i className={`${u.icon} text-xl`} />
                </div>
                <div>
                  <h4
                    className="text-sm md:text-base text-foreground-900 font-medium mb-1"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {u.title}
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">{u.body}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={100}>
          <h3
            className="text-xl md:text-2xl text-foreground-900 text-center mb-8"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            建議時程
          </h3>
          <div className="max-w-2xl mx-auto">
            {timeline.map((t, i) => (
              <div key={t.title} className="flex gap-5 md:gap-6">
                <div className="flex flex-col items-center">
                  <span
                    className={`w-3 h-3 rounded-full shrink-0 mt-1.5 ${
                      i === timeline.length - 1 ? 'bg-primary-500' : 'bg-primary-400'
                    }`}
                  />
                  {i !== timeline.length - 1 && (
                    <span className="w-px flex-1 bg-background-300/60 my-1" />
                  )}
                </div>
                <div className="pb-7 min-w-0">
                  <p className="text-xs md:text-sm text-primary-700 font-medium mb-1 whitespace-nowrap">
                    {t.date}
                  </p>
                  <h4
                    className="text-sm md:text-base text-foreground-900 font-medium"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {t.title}
                  </h4>
                  <p className="text-sm text-foreground-500 mt-1">{t.body}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}